
import React from "react";

export const HamburgerIcon = () => {
    return (
        <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.75 1.5C0.75 0.809644 1.30964 0.25 2 0.25H26C26.6904 0.25 27.25 0.809644 27.25 1.5C27.25 2.19036 26.6904 2.75 26 2.75H2C1.30964 2.75 0.75 2.19036 0.75 1.5Z" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0.75 9.5C0.75 8.80964 1.30964 8.25 2 8.25H26C26.6904 8.25 27.25 8.80964 27.25 9.5C27.25 10.1904 26.6904 10.75 26 10.75H2C1.30964 10.75 0.75 10.1904 0.75 9.5Z" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0.75 17.5C0.75 16.8096 1.30964 16.25 2 16.25H26C26.6904 16.25 27.25 16.8096 27.25 17.5C27.25 18.1904 26.6904 18.75 26 18.75H2C1.30964 18.75 0.75 18.1904 0.75 17.5Z" fill="currentColor" />
        </svg>

    )
}